export function latin1Safe(value) {
    if (!value) return true; // let `required` handle empties
    return !/[^\x00-\xFF]/.test(value); // eslint-disable-line no-control-regex
}